import type { FaireProductEntity } from "../../entity_types/product";

export const p_hpaasbytec: FaireProductEntity = {
  token: "p_hpaasbytec",
  type: "product",
  name: "Vintage 18K Gold Plated Evil Eye Charm Necklace",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/5b69d68ebefa96e4eafa856aa4664166d860f25fae470ec7f58776dcad7c7626.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5535d6e8a45dfb40f366f2820e2dbecd5d506cccaf26ce0999f08e370f9fb7d6.jpeg",
    "https://cdn.faire.com/fastly/57fabbd34feb3a25d9c39fb6adf82f222465e8de1824b1d7e567be547c970511.jpeg",
    "https://cdn.faire.com/fastly/7fa2fce0b32d482625c32f3bc147da8a4e45f5a9219dce35349f6afd3c926a71.jpeg",
  ],
  priceDollars: 19.22,
  description:
    "Type: pendant necklace\nMaterial : Alloy，Cubic zirconia，Pearl，18K Gold plated\nSize of pendant ： 35mm *56mm\nlength of chain : 380mm +60mm\n\n★Made of high quality material, Nickel-free / Lead-free， Harmless to Human Body.\n\n\n★Perfect jewelry gifts\n",
  tags: [],
  msrpDollars: 46.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:24.202Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
